<template>
  <div class=" tw-max-w-4xl tw-m-0 tw-m-auto tw-text-sm tw-font-sans tw-p-5 tw-border-solid tw-border tw-border-gray-200 tw-rounded tw-overflow-hidden tw-shadow-md tw-text-gray-600">
    <p v-if="errors.length" class="tw-bg-orange-200 tw-p-5 tw-mb-5 tw-border-solid tw-border tw-border-red-600">
      <b>Por favor, corrija o(s) seguinte(s) erro(s):</b>
      <ul>
      <li v-for="error in errors" class="tw-ml-5 tw-text-red-600">{{ error }}</li>
      </ul>
    </p>
    <div class="all-user tw-pb-2 tw-pl-8 " v-bind:class="{'tw-font-semibold' : this.showElement == 'all'}">
      <input type="radio" id="all" value="all" v-model="showElement" v-on:click="selectAllPatients">
      <label for="all">Todos os pacientes</label>
    </div>
    <div class="gender-or-age tw-pb-2 tw-pl-8 tw-pt-4" v-bind:class="{'tw-font-semibold' : this.showElement == 'gender-or-age'}">
      <input type="radio" id="gender-or-age" value="gender-or-age" v-model="showElement">
      <label for="gender-or-age">Separar por genero e/ou idade</label>
      <div class="tw-ml-5 tw-pt-5" v-show="showElement === 'gender-or-age'">
        <label for="gender" class="tw-font-medium">Gênero: </label>
        <select class="tw-p-1 tw-bg-white tw-border-solid tw-border tw-border-gray-500" name="" id="gender" @change="changeGenderOrAge($event)" v-model="gender">
          <option value=""></option>
          <option value="female">Feminino</option>
          <option value="male">Masculino</option>
        </select>
        <label for="age" class="tw-ml-10 tw-font-medium">Idade: </label>
        <select class="tw-p-1 tw-bg-white tw-border-solid tw-border tw-border-gray-500" name="" id="age" @change="changeGenderOrAge($event)" v-model="age">
          <option value=""></option>
          <option value="0-14">Entre 0 e 14 anos</option>
          <option value="15-24">Entre 15 e 24 anos</option>
          <option value="25-34">Entre 25 e 34 anos</option>
          <option value="35-44">Entre 35 e 44 anos</option>
          <option value="45-54">Entre 45 e 54 anos</option>
          <option value="55-64">Entre 55 e 64 anos</option>
          <option value="65-100">Maiores que 65 anos</option>
        </select>
      </div>
    </div>
    <div class="procedure-or-date tw-pb-2 tw-pl-8 tw-pt-4" v-bind:class="{'tw-font-semibold' : this.showElement == 'procedure-or-date'}">
      <input type="radio" id="procedure-or-date" value="procedure-or-date" v-model="showElement" v-on:click="getProcedures" >
      <label for="procedure-or-date">Separar procedimento e data de realização</label>
      <div class="tw-ml-5 tw-pt-5" v-show="showElement === 'procedure-or-date'">
        <label class="tw-font-medium">Procedimento:</label>
        <select class="tw-p-1 tw-bg-white tw-border-solid tw-border tw-border-gray-500" name="" id="procedures" v-model="selectedProcedure" @change="changeProcedureOrDate($event)">
          <option v-for="(procedure, i) in procedures" v-bind:value="procedure['id']" :key="`${i}-${procedure['id']}`">{{procedure['name']}}</option>
        </select>
        <div class="tw-mt-5">
          <label class="tw-font-medium">Entre as datas:</label>
          <custom-date-range-picker :dates="dates" @dates-submitted="changeProcedureOrDate"></custom-date-range-picker>
        </div>
      </div>
    </div>
    <div class="date-appointment tw-pb-2 tw-pl-8 tw-pt-4" v-bind:class="{'tw-font-semibold' : this.showElement == 'date-appointment'}">
      <input type="radio" id="date-appointment" value="date-appointment" v-model="showElement">
      <label for="date-appointment">Separar por data da consulta</label>
      <div v-show="showElement === 'date-appointment'">
        <div class="tw-mt-5 tw-ml-5">
          <label class="tw-font-medium">Consulta entre as datas</label>
          <custom-date-range-picker :dates="dates" @dates-submitted="changeDateAppointment"></custom-date-range-picker>
        </div>
      </div>
      <br>
    </div>
    <div class="date-appointment tw-pb-2 tw-pl-8 tw-pt-4">
      <label for="date-appointment">Com a última consulta até o dia:</label>
      <custom-date-picker-blank :dates="dateOfLastAppointment" @dates-submitted="changeLastAppointment" ></custom-date-picker-blank>
    </div>
    <hr class="alt short tw-my-2.5">
    <div class="tw-ml-5">
      <div class="total-patients tw-pb-6 tw-pt-5">
        <div>Total:
          <span v-if="!load" class="tw-text-base tw-text-green-600 tw-font-bold"> {{affected_patients}} pacientes atingidos</span>
          <span v-else class="tw-text-lg tw-text-green-600 tw-font-bold"><img class="tw-inline" v-bind:src="railsImage"></span>
        </div>
      </div>
      <div class="debtor tw-pb-5">
        <input type="checkbox" id="send-to-debtor" value="Jack" v-model="urlComposition.settings.debtor" >
        <label for="send-to-debtor">Não enviar para inadimplentes</label>
      </div>
      <div class="send-date tw-pb-5">
        <label for="send_date">Data de envio da mensagem:</label>
        <custom-date-picker :dates="sendDate" ></custom-date-picker>
      </div>
      <div class="message tw-pb-2">
        <label for="message" class="tw-block">Mensagem</label>
        <textarea id="message" class="tw-border-2 tw-w-full sm:tw-w-full md:tw-w-3/5 lg:tw-w-3/5 xl:tw-w-3/5" maxlength="150" rows="3" required v-model.trim="urlComposition.message"></textarea>
        <div class="tw-w-full sm:tw-w-full md:tw-w-3/5 lg:tw-w-3/5 xl:tw-w-3/5">
          <div class="tw-font-sans tw--mt-1 tw-text-xs font-light">Não utilize emoticons, acentos ou quebra de linha <span class="tw-float-right">{{urlComposition.message.length}} / 150</span></div>
        </div>
      </div>
    </div>
    <div class="modal-footer tw--ml-5 tw--mr-5 tw--mb-5 tw-pr-5 tw-pl-5 tw-pb-5 tw-pt-5">
      <a href="/campaigns">
        <button name="commit" class="btn btn-blue-secondary tw-float-left">Cancelar</button>
      </a>
      <div v-if="!load">
        <button class="btn btn-blue tw-text-sm tw-float-right" v-on:click="saveCampaign">Ativar campanha</button>
      </div>
      <div v-else>
        <img class="tw-text-sm tw-float-right" v-bind:src="railsImage">
      </div>

    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import railsImage from 'images/spinner.svg';
  // prevent CSRF erro for Rails
  axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
  }
  export default {
    data() {
      return {
        railsImage,
        load: false,
        errors: [],
        totalAllPatients: 0,
        showElement: '',
        affected_patients: 0,
        gender: '',
        age: '',
        selectedProcedure: '',
        procedures: '',
        dates: {
          start: moment().startOf("month"),
          end: moment().endOf("month")
        },
        dateOfLastAppointment: { start: false },
        lastStatisticsUrl: '',
        sendDate: {
          start: moment().add(1, 'days')
        },
        urlComposition: {
          message: '',
          settings: {
            custom_type: '',
            gender: '',
            age: '',
            procedure: '',
            date_start: '',
            date_end: '',
            send_date: '',
            debtor: '',
            date_of_last_appointment: ''
          }
        },
      };
    },
    methods: {
      selectAllPatients() {
        this.cleanUri();
        this.axiosParams('statistics', ['total_patients=true']).then(response => {
          this.affected_patients = response
        })
      },
      changeGenderOrAge() {
        this.cleanUri();
        this.urlComposition.settings.gender = this.gender
        this.urlComposition.settings.age = this.age
        this.axiosParams('statistics', ['gender_or_age=true', 'gender='+this.gender, 'age='+this.age]).then(response => {
          this.affected_patients = response
        })
      },
      changeProcedureOrDate() {
        this.cleanUri();
        this.urlComposition.settings.procedure = this.selectedProcedure
        this.urlComposition.settings.date_start = this.dates.start.unix()
        this.urlComposition.settings.date_end = this.dates.end.unix()
        if (! this.selectedProcedure) {
          return
        }
        this.axiosParams('statistics', ['procedure_or_date=true', 'procedure_id='+this.selectedProcedure, 'date_start='+this.dates.start.unix(), 'date_end='+this.dates.end.unix()]).then(response => {
          this.affected_patients = response
        })
      },
      changeDateAppointment() {
        this.cleanUri();
        this.urlComposition.settings.date_start = this.dates.start.unix()
        this.urlComposition.settings.date_end = this.dates.end.unix()
        this.axiosParams('statistics', ['date_appointment=true', 'date_start='+this.dates.start.unix(), 'date_end='+this.dates.end.unix()]).then(response => {
          this.affected_patients = response
        })
      },
      getProcedures() {
        this.axiosParams('procedures', ['get_procedures=true']).then(response => {
          this.procedures = response
        })
      },
      changeLastAppointment() {
        if (this.lastStatisticsUrl == '?get_procedures=true') {
          return
        }
        var urlRequest = this.lastStatisticsUrl
        if (this.dateOfLastAppointment.start != '') {
          urlRequest =  this.lastStatisticsUrl+'&date_of_last_appointment='+this.dateOfLastAppointment.start.unix()
        }
        this.fetch('statistics', urlRequest).then(response => {
          this.affected_patients = response
        })
      },
      saveCampaign() {
        //Validations
        this.errors = [];
        if (this.urlComposition.message.length <= 30) {
          this.errors.push("Sua mensagem está muito pequena.")
          window.scrollTo(0, 0);
          return
        }
        if (this.urlComposition.message.length > 150) {
          this.errors.push("Sua mensagem está muito longa.")
          window.scrollTo(0, 0);
          return
        }
        if ((this.urlComposition.settings.custom_type == 'gender_or_age') && (!this.gender && ! this.age)) {
          this.errors.push("Selecione a idade ou o genero")
          window.scrollTo(0, 0);
          return
        }
        if ((this.urlComposition.settings.custom_type == 'procedure_or_date') && !this.selectedProcedure) {
          this.errors.push("Selecione o procedimento")
          window.scrollTo(0, 0);
          return
        }
        if (this.affected_patients == 0) {
          this.errors.push("Sua campanha não vai alcançar ninguém")
          window.scrollTo(0, 0);
          return
        }
        this.urlComposition.settings.send_date = this.sendDate.start.unix()
        if (this.dateOfLastAppointment.start) {
          this.urlComposition.settings.date_of_last_appointment =  this.dateOfLastAppointment.start.unix()
        }
        this.load = true
        this.urlComposition.authenticity_token =  document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        axios.post(`/custom-campaign/create-custom-campaign`, this.urlComposition).then(response => {
          window.location = "/campaigns?custom_campaign_created=true"
        }).catch((error) => {
          this.errors.push("Ocorreu um erro ao ativar. Confira as informações e tente novamente. Se o erro persistir, contate o suporte.")
          this.load = false
        })
      },
      axiosParams(baseUrl, params) {
        var paramsGet = '?'
        for (var i = 0; i < params.length; i++) {
          if (params[i] != '') {
            if (paramsGet == '?') {
              paramsGet = paramsGet+params[i]
            } else {
              paramsGet = paramsGet+'&'+params[i]
            }
          }
        }
        this.lastStatisticsUrl = paramsGet
        if (this.dateOfLastAppointment.start) {
          paramsGet = paramsGet+'&date_of_last_appointment='+this.dateOfLastAppointment.start.unix()
        }
        return this.fetch(baseUrl, paramsGet).then(function(axiosResult) {
          return axiosResult
        })
      },
      fetch(baseUrl, get) {
        this.load = true
        return axios.get(`/custom-campaign/${baseUrl}${get}`)
        .then(response => {
          this.load = false
          return response.data
        })
      },
      cleanUri(){
        this.urlComposition = {
          message: this.urlComposition.message,
          settings: {
            custom_type: this.urlComposition.settings.custom_type,
            gender: '',
            age: '',
            procedure: '',
            date_start: '',
            date_end: '',
            send_date: '',
            debtor: '',
            date_of_last_appointment: this.urlComposition.settings.date_of_last_appointment
          }
        }
      }
    },
    mounted() {
      this.showElement = 'all'
      this.selectAllPatients()
    },
    watch: {
      showElement(val) {
        if (val != 'all') {
          this.affected_patients = 0
        }
        if (val == "all") {
          this.urlComposition.settings.custom_type = 'all_user'
        }
        if (val == "gender-or-age") {
          this.gender = ''
          this.age = ''
          this.urlComposition.settings.custom_type = 'gender_or_age'
        }
        if (val == 'procedure-or-date') {
          this.selectedProcedure = ''
          this.urlComposition.settings.custom_type = 'procedure_or_date'
        }
        if (val == 'date-appointment') {
          this.dates= { start: moment().startOf("month"), end: moment().endOf("month") }
          this.changeDateAppointment()
          this.urlComposition.settings.custom_type = 'date_appointment'
        }
        this.dates = { start: moment().startOf("month"), end: moment().endOf("month") }

      }
    }
  }
</script>
